import PropTypes from 'prop-types';
import React from 'react';

import { getLocaleIds, LocaleConsumer } from '../../locales';

/**
 * Export a shape for use with this HOC.
 */
export const withActiveLocalePropType = PropTypes.shape({
  id: PropTypes.oneOf(getLocaleIds()).isRequired,
  label: PropTypes.string.isRequired
});

/**
 * A HOC component that applies an "activeLocale" prop. This is the
 * locale the user is currently under.
 *
 * activeLocale = {
 *   id: 'en',
 *   label: 'English - Canada'
 * };
 *
 * @param {Component} WrappedComponent React component to wrap.
 */
export function withActiveLocale(WrappedComponent) {
  function WithActiveLocale(props) {
    return (
      <LocaleConsumer>{(activeLocale) => <WrappedComponent {...props} activeLocale={activeLocale} />}</LocaleConsumer>
    );
  }

  WithActiveLocale.displayName = `withActiveLocale(${WrappedComponent?.displayName || WrappedComponent?.name})`;

  return WithActiveLocale;
}

export default withActiveLocale;
